import React from "react";
import Header from "../components/Header";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCreative } from "swiper/modules";

import "swiper/css";
import 'swiper/css/effect-creative';

import {
  FaWhatsapp,
  FaEnvelope,
  FaPaperPlane,
} from "react-icons/fa";

import DemoAudio from "../components/DemoAudio";


function Home() {
  return (
    <>
      <Header />

      <main className="home-page">

        <div className="home-flow-shell">

        {/* =================================================
              GLOWS COMPARTIDOS
          ================================================= */}

          {/* Superior - zona Quién soy */}
          <div className="home-flow-shell__glow home-flow-shell__glow--hero-left" />

          <div className="home-flow-shell__glow home-flow-shell__glow--hero-right" />


          {/* Transición Quién soy -> Demos */}
          <div className="home-flow-shell__glow home-flow-shell__glow--about-demos" />


          {/* Zona Demos */}
          <div className="home-flow-shell__glow home-flow-shell__glow--demos-left" />

          <div className="home-flow-shell__glow home-flow-shell__glow--demos-right" />


          {/* Transición Demos -> Contacto */}
          <div className="home-flow-shell__glow home-flow-shell__glow--demos-contact" />


          {/* Zona Contacto */}
          <div className="home-flow-shell__glow home-flow-shell__glow--contact" />


          {/* Remate Footer */}
          <div className="home-flow-shell__glow home-flow-shell__glow--bottom" />

          {/* =====================================================
              HERO / PORTADA
          ===================================================== */}
          <section
            id="quien-soy"
            className="home-section home-hero"
          >
            {/* Elementos decorativos */}
              <div className="home-hero__glow home-hero__glow--one" />

              <div className="home-hero__glow home-hero__glow--top-right" />

              <div className="home-hero__glow home-hero__glow--two" />

              <div className="home-container">

                  <div className="home-hero__grid">

                  {/* =================================================
                      COLUMNA IZQUIERDA
                  ================================================= */}
                  <div className="home-hero__content">

                      <div className="home-hero__eyebrow hero-animate hero-animate--1">
                      <span className="home-hero__eyebrow-line" />

                      <span>
                          Voz que conecta
                      </span>
                      </div>


                      <h1 className="home-hero__title hero-animate hero-animate--2">
                      Mónica 
                      Palacios
                      </h1>


                      <p className="home-hero__description hero-animate hero-animate--3">
                      Locutora comercial con base en Ciudad de México, comunicóloga con
                      especialización en radio y televisión y profesional de la voz en formación constante.
                      </p>

                      <p className="home-hero__description hero-animate hero-animate--3">
                      Llevo más de cinco años preparándome en técnica, interpretación y desarrollo vocal.
                      Cuento con herramientas que me permiten dar intención, sensibilidad y claridad a cada
                      proyecto.
                      </p>

                      <p className="home-hero__description hero-animate hero-animate--3">
                        Mi formación como comunicóloga me ha dado una perspectiva muy valiosa dentro de este
                        camino. Me ayuda a entender que detrás de cada guión hay una intención, una marca, una
                        audiencia y un objetivo específico. Por eso, además de interpretar un texto, busco
                        comprender lo que el cliente realmente quiere comunicar para conectar mejor con su
                        mensaje.

                      </p>

                      <p className="home-hero__description hero-animate hero-animate--3">
                        Mi objetivo no es sólo aportar una voz que suene bien, sino que transmita de forma
                        auténtica, empática y efectiva. Creo en el poder de la voz como un puente entre las ideas y
                        las emociones, y disfruto trabajar cada proyecto con profesionalismo, atención al detalle y
                        compromiso.

                      </p>

                      <p className="home-hero__description hero-animate hero-animate--3">
                        Encontrarás en mí, dedicación, preparación y entusiasmo, además de la convicción que una
                        buena locución nace de saber escuchar, interpretar y comunicar con intención.
                      </p>


                      {/* =============================================
                          CTA
                      ============================================= */}
                      <div className="home-hero__actions hero-animate hero-animate--4">

                      <button
                          type="button"
                          className="home-hero__button home-hero__button--primary"
                          onClick={() => {
                          document
                              .getElementById("demos")
                              ?.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                              });
                          }}
                      >
                          Escuchar demos

                          <span className="home-hero__button-arrow">
                          →
                          </span>
                      </button>


                      <a
                          href="mailto:contacto@tudominio.com"
                          className="home-hero__button home-hero__button--secondary"
                      >
                          Enviar correo
                      </a>

                      </div>


                      {/* =============================================
                          CARDS
                      ============================================= */}
                      {/* <div className="home-hero__services hero-animate hero-animate--5">

                      <article className="home-hero__service-card">
                          <div className="home-hero__service-icon">
                          C
                          </div>

                          <div>
                          <h3>
                              Comercial
                          </h3>

                          <p>
                              Spots, campañas, social ads y promos.
                          </p>
                          </div>
                      </article>


                      <article className="home-hero__service-card">
                          <div className="home-hero__service-icon">
                          I
                          </div>

                          <div>
                          <h3>
                              Institucional
                          </h3>

                          <p>
                              Videos corporativos, capacitación y narración.
                          </p>
                          </div>
                      </article>


                      <article className="home-hero__service-card">
                          <div className="home-hero__service-icon">
                          D
                          </div>

                          <div>
                          <h3>
                              Dirección
                          </h3>

                          <p>
                              Lectura con intención, marca y audiencia.
                          </p>
                          </div>
                      </article>

                      </div> */}

                  </div>


                  {/* =================================================
                      COLUMNA DERECHA / CARRUSEL
                  ================================================= */}
                  <div className="home-hero__visual hero-animate hero-animate--visual">

                    <div className="home-hero__image-card">

                      <div className="home-hero__image-wrapper">

                        <Swiper
                          modules={[Autoplay, EffectCreative]}
                          effect="creative"
                          creativeEffect={{
                            prev: {
                              shadow: true,
                              translate: ['-20%', 0, -1],
                            },
                            next: {
                              translate: ['100%', 0, 0],
                            },
                          }}
                          loop={true}
                          speed={1200}
                          allowTouchMove={false}
                          autoplay={{
                            delay: 4500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                          }}
                          className="home-hero__swiper"
                        >

                          <SwiperSlide>
                            <img
                              src="/assets/img/monica-palacios.jpg"
                              alt="Mónica Palacios en sesión profesional"
                              className="home-hero__image"
                            />
                          </SwiperSlide>

                          <SwiperSlide>
                            <img
                              src="/assets/img//monica-palacios.jpg"
                              alt="Mónica Palacios en estudio de locución"
                              className="home-hero__image"
                            />
                          </SwiperSlide>

                          <SwiperSlide>
                            <img
                              src="/assets/img/monica-palacios.jpg"
                              alt="Mónica Palacios durante una sesión de voz"
                              className="home-hero__image"
                            />
                          </SwiperSlide>

                        </Swiper>

                        <div className="home-hero__image-overlay" />

                      </div>


                      {/* =============================================
                          CARD SOBRE IMAGEN
                      ============================================= */}
                      <div className="home-hero__voice-card">

                        <span className="home-hero__voice-label">
                          Voz profesional
                        </span>

                        <h2>
                          Una voz natural,
                          cercana y confiable.
                        </h2>

                        <p>
                          Diseñada para convertir una primera visita
                          en escucha de demo y contacto directo.
                        </p>

                      </div>

                    </div>

                  </div>

                  </div>

              </div>
          </section>

        {/* =====================================================
              TRANSICIÓN QUIÉN SOY -> DEMOS
          ===================================================== */}
          <div
            className="home-flow-shell__bridge home-flow-shell__bridge--about"
            aria-hidden="true"
          >
            <span />
          </div>


          {/* =====================================================
              DEMOS
          ===================================================== */}
          <section
            id="demos"
            className="home-section home-section--demos"
          >
            <div className="home-container">

              {/* =================================================
                  ENCABEZADO
              ================================================= */}
              <div className="demos-section__header">

                <div className="demos-section__eyebrow">
                  <span className="demos-section__eyebrow-line" />

                  <span>
                    Escucha mi trabajo
                  </span>
                </div>


                <div className="demos-section__heading">

                  <h2>
                    Demos de voz
                  </h2>

                  <p>
                    Dos estilos de locución pensados para comunicar
                    con intención, claridad y personalidad.
                  </p>

                </div>

              </div>


              {/* =================================================
                  GRID
              ================================================= */}
              <div className="demos-section__grid">

                {/* =================================================
                    DEMO COMERCIAL
                ================================================= */}
                <article className="demo-card demo-card--commercial">

                  <div className="demo-card__decoration" />


                  <div className="demo-card__content">

                    <span className="demo-card__tag">
                      Demo comercial
                    </span>


                    <div className="demo-card__main">

                      <h3>
                        Para campañas, marcas y{" "}
                        <br className="demo-card__desktop-break" />
                        contenido publicitario.
                      </h3>

                      <p>
                        Una muestra de mi registro comercial y de las distintas
                        posibilidades de mi voz: desde tonos cercanos, naturales
                        y conversacionales, hasta interpretaciones con mayor energía,
                        intención y dinamismo.
                      </p>

                      <p>
                        Mi voz se adapta especialmente a mensajes que buscan sentirse
                        actuales, frescos y auténticos, manteniendo siempre claridad
                        y conexión con quien escucha.
                      </p>

                    </div>


                    <DemoAudio
                      src="/assets/audio/DEMO MONICA PALACIOS V3.mp3"
                      label="Demo comercial de Mónica Palacios"
                    />


                    <div className="demo-card__footer">

                      <span className="demo-card__footer-label">
                        Escucha una muestra
                      </span>

                      <span className="demo-card__footer-line" />

                    </div>

                  </div>

                </article>


                {/* =================================================
                    DEMO INSTITUCIONAL
                ================================================= */}
                <article className="demo-card demo-card--institutional">

                  <div className="demo-card__decoration" />


                  <div className="demo-card__content">

                    <span className="demo-card__tag">
                      Demo institucional
                    </span>


                    <div className="demo-card__main">

                      <h3>
                        Para mensajes corporativos,
                        <br className="demo-card__desktop-break" />
                        educativos y narrativos.
                      </h3>

                      <p>
                        En este demo exploro mi registro narrativo e institucional,
                        con una voz cálida, clara y cercana que puede transitar entre
                        la naturalidad, la sensibilidad y un tono más profesional.
                      </p>

                      <p>
                        Un estilo pensado para contenidos que necesitan comunicar
                        con confianza y credibilidad, sin perder cercanía ni sentirse
                        rígidos o excesivamente serios.
                      </p>

                    </div>


                    <DemoAudio
                      src="/assets/audio/DEMO MONICA PALACIOS NARRATIVO CORPORATIVO.wav"
                      label="Demo narrativo corporativo de Mónica Palacios"
                    />


                    <div className="demo-card__footer">

                      <span className="demo-card__footer-label">
                        Escucha una muestra
                      </span>

                      <span className="demo-card__footer-line" />

                    </div>

                  </div>

                </article>

              </div>

            </div>
          </section>

          {/* =====================================================
              TRANSICIÓN QUIÉN SOY -> DEMOS
          ===================================================== */}
          <div
            className="home-flow-shell__bridge home-flow-shell__bridge--about"
            aria-hidden="true"
          >
            <span />
          </div>


          {/* =====================================================
              CONTACTO
          ===================================================== */}
          <section
            id="contacto"
            className="home-section home-section--contacto"
          >

            <div className="contact-section__line-art">
              <span />
              <span />
              <span />
            </div>


            <div className="home-container">

              <div className="contact-section__grid">

                {/* IZQUIERDA */}
                <div className="contact-section__content">

                  <div className="contact-section__eyebrow">
                    <span className="contact-section__eyebrow-line" />

                    <span>
                      Contacto
                    </span>
                  </div>


                  <h2 className="contact-section__title">
                    ¿Tienes un proyecto en puerta?
                  </h2>


                  <p className="contact-section__description">
                    Cuéntame qué necesitas comunicar y trabajemos
                    en una voz que conecte con tu marca, audiencia
                    y objetivo.
                  </p>


                  <p className="contact-section__secondary-text">
                    Puedes compartir tu guion, solicitar disponibilidad,
                    pedir una cotización o simplemente contarme un poco
                    sobre tu proyecto.
                  </p>


                  <div className="contact-section__actions">

                    <a
                      href="https://wa.me/525530098562"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-section__button contact-section__button--primary"
                    >
                      <FaWhatsapp />

                      <span>
                        WhatsApp
                      </span>
                    </a>


                    <a
                      href="mailto:monicapalaciosgm2@gmail.com"
                      className="contact-section__button contact-section__button--secondary"
                    >
                      <FaEnvelope />

                      <span>
                        Enviar correo
                      </span>
                    </a>

                  </div>

                </div>


                {/* FORMULARIO */}
                <div className="contact-form-wrapper">

                  <div className="contact-form__header">

                    <span>
                      Cuéntame sobre tu proyecto
                    </span>

                    <p>
                      Déjame tus datos y me pondré en contacto contigo.
                    </p>

                  </div>


                  <form
                    className="contact-form"
                    onSubmit={(event) => {
                      event.preventDefault();
                    }}
                  >

                    <div className="contact-form__row">

                      <div className="contact-form__group">
                        <label htmlFor="contact-name">
                          Nombre
                        </label>

                        <input
                          id="contact-name"
                          name="name"
                          type="text"
                          placeholder="Tu nombre"
                          autoComplete="name"
                          required
                        />
                      </div>


                      <div className="contact-form__group">
                        <label htmlFor="contact-email">
                          Correo
                        </label>

                        <input
                          id="contact-email"
                          name="email"
                          type="email"
                          placeholder="correo@ejemplo.com"
                          autoComplete="email"
                          required
                        />
                      </div>

                    </div>


                    <div className="contact-form__group">

                      <label htmlFor="contact-project">
                        Tipo de proyecto
                      </label>

                      <select
                        id="contact-project"
                        name="project"
                        defaultValue=""
                        required
                      >
                        <option value="" disabled>
                          Selecciona una opción
                        </option>

                        <option value="comercial">
                          Locución comercial
                        </option>

                        <option value="institucional">
                          Locución institucional
                        </option>

                        <option value="narracion">
                          Narración
                        </option>

                        <option value="otro">
                          Otro proyecto
                        </option>
                      </select>

                    </div>


                    <div className="contact-form__group">

                      <label htmlFor="contact-message">
                        Cuéntame qué necesitas grabar
                      </label>

                      <textarea
                        id="contact-message"
                        name="message"
                        rows="6"
                        placeholder="Platícame brevemente sobre tu proyecto, duración estimada, estilo de voz, fecha de entrega o cualquier información importante."
                        required
                      />

                    </div>


                    <button
                      type="submit"
                      className="contact-form__submit"
                    >
                      <span>
                        Enviar solicitud
                      </span>

                      <FaPaperPlane />
                    </button>


                    <p className="contact-form__privacy">
                      La información enviada será utilizada únicamente
                      para responder tu solicitud.
                    </p>

                  </form>

                </div>

              </div>

            </div>

          </section>


          {/* =====================================================
              FOOTER
          ===================================================== */}
          <footer className="site-footer">

            <div className="home-container">

              <div className="site-footer__content">

                <p className="site-footer__copyright">
                  © {new Date().getFullYear()} Mónica Palacios.
                  Todos los derechos reservados.
                </p>

              </div>

            </div>

          </footer>

        </div>

      </main>
    </>
  );
}

export default Home;